import React, { Component } from "react";
import styled from "styled-components";
import { Redirect } from 'react-router-dom';

// Utils //
import history from "utils/history";

// HOC //
import withChat from "hoc/withChat";

// Components //
import CodeEditor from "components/CodeEditor";
import Text from "components/Text";
import StepHeader from 'components/StepHeader';
import StepFooter from 'components/StepFooter';
import SuccessMessage from 'components/SuccessMessage';
import ErrorMessage from 'components/ErrorMessage';

const Root = styled.div``;

const Header = styled(StepHeader)`
  margin-bottom: 40px;
`;

class Step5 extends Component {
  state = {
    hasRan: false,
    value: `const parent = await channel.sendMessage({
  text: 'Episode 1 just blew my mind!',
});

const reply = await channel.sendMessage({
  text: "Stop it, no spoilers please!",
  parent_id: parent.message.id,
  customField: 123, // custom field, you can add as many as you want
});`
  };

  run = async () => {
    const { channel, match, setLoading, setError, setStepComplete } = this.props; // eslint-disable-line no-unused-vars
    const { value } = this.state;

    try {
      await setLoading(true);
      eval(`(async () => {${value}})();`); // eslint-disable-line no-eval
      await setStepComplete(4);
      await setLoading(false);

      this.setState({ hasRan: true });
    } catch (err) {
      await setLoading(false);
      setError(err.message);
    }
  };

  handleCodeChange = value => {
    this.setState({
      value
    });
  };

  handlePrevClick = () => history.push(`/step-4`);

  handleNextClick = () => history.push(`/step-6`);

  render() {
    const { client, channel, completedSteps, error, loading } = this.props;
    const { hasRan, value } = this.state;
    const isComplete = completedSteps.includes(4);

    if (!client || !channel) {
      return <Redirect to="/step-1" />
    }

    return (
      <Root>
        <Header
          step={5}
          title="Start a Thread"
        >
          <Text size={18}>
            For team style use cases such as Slack you’ll want to support replies and threads. You can create a thread of messages by specifying a <b>parent_id</b> on a new message:
          </Text>
        </Header>
        <CodeEditor
          onChange={this.handleCodeChange}
          onRunClick={this.run}
          value={value}
          runLabel="Start Thread"
        />
        {hasRan && (
          <SuccessMessage
            style={{marginTop: 16}}
            text="Thread Created."
          />
        )}
        <StepFooter
          disableNext={!isComplete && !hasRan}
          loading={loading}
          onPrevClick={this.handlePrevClick}
          onNextClick={this.handleNextClick}
        />
        {error && <ErrorMessage
          error={error}
        />}
      </Root>
    );
  }
}

export default withChat(Step5);
